import LinkedInAccountsTag from "../LinkedInAccountsTag";
import SectionContainer from "./SectionContainer";

export default function LeadOf({ leadOf }: { leadOf: string[] }) {
  if (!leadOf.length) {
    return;
  }

  return (
    <SectionContainer title="Can chat with" isColumn hasBorder>
      <div className="flex gap-1.5 flex-wrap">
        {leadOf.map((accountId) => (
          <LinkedInAccountsTag
            key={accountId}
            accountIds={[accountId]}
            size="md"
          />
        ))}
      </div>
    </SectionContainer>
  );
}
